import React from "react";

import svg from "../../assets/images/icons/drag.svg";

export const DragIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Drag"}
    />
);
